<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
  <form class="kt-form w-webkit-fill-available" [formGroup]="form">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header">
        <h5 class="modal-title">{{ data.mode == "edit" ? "Edit" : data.mode == 'create' ? "Create" : "Duplicate" }} Operator Role</h5>
        <span class="modal-x-button" (click)="unsavedChangesCloseDialog()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </span>
      </div>
      <!-- Body -->
      <div class="modal-body">
        <!-- Name -->
        <div class="col-12 form-group row pr-0">
          <label class="col-2 col-form-label">Name <span class="text-danger">*</span> </label>
          <input type="text" formControlName="name" min="1" class="col-10 form-control" [ngStyle]="{ padding: '5px 10px' }" />
        </div>
        <!-- Status -->
        <div class="col-12 form-group row pr-0">
          <label class="col-2 col-form-label">Status <span class="text-danger">*</span> </label>
          <select formControlName="status" class="col-10 pl-2 form-control">
            <option *ngFor="let value of dropdown.statuses; let i = index" [value]="i">{{ value }}</option>
          </select>
        </div>
        <div class="col-12 form-group row pr-0">
          <label class="col-2 col-form-label">
            Parent Role <span class="text-danger">*</span> 
            <i
              class="ml-1 fas fa-info-circle"
              matTooltipClass="custom-tooltip"
              matTooltipHideDelay="0"
              matTooltip="Parent role has higher permissions and can view or edit this role's settings"
              matTooltipPosition="above">
            </i>
          </label>
          <div class="col-10 pl-0">
            <kt-dropdown-wo-lazyload
              [form]="form"
              [dropdownList]="dropdown.parents"
              [dropdownSettings]="parentRoleDropdownSettings"
              [formName]="'parent_id'"
              [selectionAttributes]="'id'"
              [selectedItems]='parentRoleSelectedItems'
              (selectedItemsChanged)="onParentRoleChange($event)"
            ></kt-dropdown-wo-lazyload>
          </div>
        </div>
        <div class="col-12 form-group row pr-0">
          <label class="col-2 col-form-label">
            Child Role 
            <i
              class="ml-1 fas fa-info-circle"
              matTooltipClass="custom-tooltip"
              matTooltipHideDelay="0"
              matTooltip="Child roles have lower permissions and cannot view or edit this role's settings"
              matTooltipPosition="above">
            </i>
          </label>
          <div class="col-10 pl-0">
            <kt-dropdown-wo-lazyload
              [form]='form'
              [dropdownList]='dropdown.children'
              [dropdownSettings]='childRoleDropdownSettings'
              [formName]="'children_ids'"
              [selectionAttributes]="'id'"
              [selectedItems]='childRoleSelectedItems'
              (selectedItemsChanged)="onChildRoleChange($event)"
            ></kt-dropdown-wo-lazyload>
          </div>
        </div>
        <!-- Remarks -->
        <div class="col-12 form-group row pr-0">
          <label class="col-2 col-form-label">Remarks </label>
          <input type="text" formControlName="remarks" min="1" class="col-10 form-control" />
        </div>

        <!-- Permissions Div -->
        <div class="col-12 form-group mb-0" formGroupName="permissions">
          <div class="card p-3">
            <!-- Button & Search Input Group -->
            <div class="row">
              <div class="col-7">
                <button
                  class="btn btn-success btn-icon-sm mr-2"
                  (click)="selectDeselectAllPermissions(true)"
                >
                  <i class="fas fa-check"></i>{{ 'Select All' | translate }}
                </button>
                <button
                  class="btn btn-danger btn-icon-sm mr-2"
                  (click)="selectDeselectAllPermissions(false)"
                >
                  <i class="fas fa-times"></i>{{ 'Deselect All' | translate }}
                </button>
                <button
                  class="btn btn-icon-sm expand-all-btn mr-2"
                  (click)="toggleAllExpansionPanel(true)"
                >
                  <i class="fas fa-expand-alt"></i>{{ 'Expand All' | translate }}
                </button>
                <button
                  class="btn btn-icon-sm collapse-all-btn"
                  (click)="toggleAllExpansionPanel(false)"
                >
                  <i class="fas fa-compress-alt"></i>{{ 'Collapse All' | translate }}
                </button>
              </div>

              <div class="col-5 input-group-append search-filter h-100 w-100">
                <select
                  class="form-control"
                  (change)="onSelectSearchBarType($event)"
                  [ngStyle]="{ width: '250px' }"
                >
                  <option [value]="null" disabled>Please Select</option>
                  <option *ngFor="let value of searchBarTypes;" [value]="value.code">{{ value.name }}</option>
                </select>
                <kt-dropdown-wo-lazyload
                  [form]="searchForm"
                  [dropdownList]="searchElementsData"
                  [dropdownSettings]="searchFilterDropdownSettings"
                  formName="search"
                  [selectionAttributes]="'id'"
                  [selectedItems]="searchBarSelectedItems"
                  style="width: 100%"
                ></kt-dropdown-wo-lazyload>
                <button class="btn btn-brand btn-icon-sm btn-search" [disabled]="searchBarBtnDisabled" (click)="onSearch()"><i class="fas fa-search"></i></button>
              </div>
            </div>

            <!-- Permissions Layers -->
            <div class="row mt-4">
              <!-- Left -->
              <div class="col-6">
                <application-role-permission-layer
                  [sectionPermissions]="data.sectionPermissions | slice : 0 : halfIndexOfSP"
                  [permissionsBySection]="permissionsBySection"
                  [sectionPanelOpenState]="sectionPanelOpenState"
                  [form]="form" 
                  (permissionChange)="permissionChangeListener($event)"
                  (permissionChangeAll)="permissionChangeAllListener($event)"
                  (sectionPanelOpenStateUpdated)="sectionPanelOpenStateUpdatedListener($event)"
                ></application-role-permission-layer>
              </div>

              <!-- Right -->
              <div class="col-6">
                <application-role-permission-layer
                  [sectionPermissions]="data.sectionPermissions | slice : halfIndexOfSP"
                  [permissionsBySection]="permissionsBySection"
                  [sectionPanelOpenState]="sectionPanelOpenState"
                  [form]="form" 
                  (permissionChange)="permissionChangeListener($event)"
                  (permissionChangeAll)="permissionChangeAllListener($event)"
                  (sectionPanelOpenStateUpdated)="sectionPanelOpenStateUpdatedListener($event)"
                ></application-role-permission-layer>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="unsavedChangesCloseDialog()"><i class="fas fa-ban"></i>Close</button>
        <kt-submit-button *ngIf="data.mode === 'create' ? canCreateApplicationRole : canEditApplicationRole" [isDisabled]="!form.valid" [buttonLoading]="buttonLoading" (confirmed)="onSave()"></kt-submit-button>
      </div>
    </div>
  </form>
</div>
<!-- Message Dialog -->
<kt-swal-alert [title]="hasInvalidPermissions ? 'Permissions Updated' : 'System Message'" [message]="messages$ | async" [iconColor]="hasInvalidPermissions ? '#ff3148' : ''" (confirmed)="onCloseDialog($event)"></kt-swal-alert>
